import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { ExtensionGroupOption } from '../models/extension-group-option';
import { extensionGroupOptionActions } from '../state/extension-group-option.actions';
import { extensionGroupOptionSelectors } from '../state/extension-group-option.reducer';

@Directive({
    selector: '[ndtExtensionGroupSelect]',
    standalone: false
})
export class ExtensionGroupSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() accountId: number | null;

   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   private destroyed$ = new Subject<void>();

   constructor(
      private elementRef: ElementRef,
      private formField: MatFormField,
      private trigger: LcsSingleSelectDirective<ExtensionGroupOption>,
      private statusService: NgrxEagerSelectService<AppState, ExtensionGroupOption>
   ) {}

   ngAfterViewInit(): void {
      let filterStr = '';

      if (this.accountId) {
         filterStr = `AccountId = ${this.accountId}`;
      }

      const staticFilterOverride = [filterStr];

      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            extensionGroupOptionActions,
            extensionGroupOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('extensionGroupId', this.trigger);
            },
            staticFilterOverride
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
